import React, { useState, useEffect, useRef } from 'react'
import { Drawer, IconButton, Panel, Row, Col, Icon, List, FlexboxGrid, Container } from 'rsuite'
import 'rsuite/dist/styles/rsuite-default.css'
import { getNotification } from '../../redux/actions/dashboard'
import { useHistory } from 'react-router'

export default function Drawered({ isShow, onClose, countNoti, onShowItem = () => {} }) {
  const [show, setShow] = useState(false)
  const [schema, setSchema] = useState()

  const history = useHistory()
  let theme = localStorage.getItem('theme')
  let fontSize = localStorage.getItem('fontSize')
  const access_token = localStorage.getItem('access_token')

  useEffect(() => {
    access_token && handelGetNotification()
  }, [])

  useEffect(() => {
    setShow(isShow)
  }, [isShow])

  const close = () => {
    onClose(false)
  }

  const handelGetNotification = async () => {
    try {
      const response = await getNotification()
      console.log('ggg => ', response)
      setSchema(response)
      // ตั้งให้เป็น 0 ก่อนเนื่องจากยังไม่มี api update การอ่านข้อความ
      // countNoti(0)
      countNoti(response?.totalRecord || 0)
    } catch (e) {
      console.log('error ', e)
    }
  }

  return (
    <>
      {schema && (
        <Drawer
          show={show}
          onHide={close}
          style={{ zIndex: 9999 }}
          size={fontSize <= 15 ? 'xs' : 'sm'}
        >
          <Drawer.Header>
            <Drawer.Title style={{ fontSize: 22, paddingTop: 8 }}>{schema.header}</Drawer.Title>
            {/* <hr /> */}
          </Drawer.Header>
          <Drawer.Body>
            {schema.values.length > 0 ? (
              schema.values.map((item, index) => {
                let _codeStr =
                  item.code.length >= 150 ? `${item.code.substring(0, 150)}...` : item.code
                return (
                  <>
                    <Panel key={'key_' + index} bordered bodyFill style={{ marginBottom: 10 }}>
                      <Container
                        key={'container_key_' + index}
                        style={{ padding: 10, cursor: 'pointer' }}
                        onClick={() => {
                          onShowItem(item, index + 1)
                        }}
                      >
                        <div style={{ wordWrap: 'break-word' }}>
                          <Icon icon="envelope" size="lg" />
                          {/* <b style={{ marginLeft: 5 }}>{`${index + 1}) ${_codeStr}`}</b> */}
                          <b style={{ marginLeft: 5 }}>
                            {/* {`${index + 1}) `}{' '} */}
                            <span dangerouslySetInnerHTML={{ __html: _codeStr }} />
                          </b>
                        </div>

                        {item?.statusName && (
                          <div style={{ wordWrap: 'break-word' }}>
                            <span>สถานะ : {item.statusName}</span>
                          </div>
                        )}

                        {item?.date && (
                          <div style={{ wordWrap: 'break-word', marginTop: 5, color: '#808080db' }}>
                            <span>{item.date}</span>
                          </div>
                        )}
                      </Container>
                    </Panel>
                  </>
                )
              })
            ) : (
              <>
                <Panel key={'key_'} bordered bodyFill>
                  <Container key={'container_key_'} style={{ padding: 10, textAlign: 'center' }}>
                    -ไม่พบรายการแจ้งเตือน-
                  </Container>
                </Panel>
              </>
            )}
          </Drawer.Body>
        </Drawer>
      )}
    </>
  )
}
